import { render, staticRenderFns } from "./CourseBuilderDialogueForm.vue?vue&type=template&id=202a83ce&scoped=true&"
import script from "./CourseBuilderDialogueForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderDialogueForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderDialogueForm.vue?vue&type=style&index=0&id=202a83ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202a83ce",
  null
  
)

export default component.exports